import { createAction, props } from '@ngrx/store';
import { IotaConfig } from 'src/app/shared/constants-and-enums/iota-config';

export const LoadIotaConfig = createAction('[IotaConfig] LoadIotaConfig');
export const LoadIotaConfigSuccess = createAction('[IotaConfig] LoadIotaConfigSuccess', props<{ iotaConfig: IotaConfig }>());
export const LoadIotaConfigFailure = createAction('[IotaConfig] LoadIotaConfigFailure', props<{ error: any }>());
